import React, { useContext } from "react";
import { Context } from "./Context";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Button, Grid, LinearProgress } from "@mui/material";

// icons
import AddIcon from "@mui/icons-material/Add";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { HorizontalStepper } from "./Stepper/HorizontalStepper";

const Table = () => {
	const {
		contextMenu,
		setContextMenu,
		columns,
		rows,
		checked,
		setChecked,
		viewActive,
		setViewActive,
	} = useContext(Context);

	return (
		<>
			<div
				onContextMenu={(event) => {
					event.preventDefault();

					setContextMenu(
						contextMenu === null
							? {
									mouseX: event.clientX + 2,
									mouseY: event.clientY - 6,
							  }
							: null
					);
				}}
			>
				{viewActive === "table" && (
					<Grid sx={{ mt: 1.5 }} container spacing={2}>
						<Grid size={9} />

						<Grid
							size={3}
							display="flex"
							justifyContent="flex-end"
							gap={2}
						>
							{/* Context Menu can be added here if needed */}
							<Button
								color="primary"
								variant="contained"
								startIcon={<AddIcon />}
								onClick={() => setViewActive("stepper")}
							>
								Crear nuevo reporte
							</Button>

							<Button color="inherit" variant="outlined">
								<AutorenewIcon />
							</Button>
						</Grid>

						<Grid size={12}>
							<DataGridPro
								showCellVerticalBorder
								showColumnVerticalBorder
								checkboxSelection
								//loading={loadingGettingEmployeeInfo}
								columns={columns}
								rows={rows}
								slots={{
									loadingOverlay: LinearProgress,
								}}
								rowSelectionModel={checked}
								onRowSelectionModelChange={(
									newRowSelectionModel
								) => {
									setChecked(newRowSelectionModel);
								}}
								sx={{
									height: `calc(100vh - 170px)`,
								}}
								hideFooter
								disableRowSelectionOnClick
							/>
						</Grid>
					</Grid>
				)}

				{viewActive === "stepper" && <HorizontalStepper />}

				{viewActive === "loading" && (
					<Grid container justifyContent="center" sx={{ mt: 2 }}>
						<LinearProgress sx={{ width: "100%" }} />
					</Grid>
				)}
			</div>
		</>
	);
};

export { Table };
